import { leaveHistoryConstants } from "../constant/leaveHistory.constant";

export const initialState = {
    history: {},
    errorCode: "",
    successCode: "",
    loading: false,
    loadingPage: false,
};
const leaveHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case leaveHistoryConstants.GET_LIST_SUCCESS:
            return {
                ...state,
                history: action.data,
                loading: true,
                loadingPage: false,
            };
        case leaveHistoryConstants.GET_LIST:
            return {
                ...state,
                loadingPage: true,
            };
        case leaveHistoryConstants.CLEAR_LOADING:
            return {
                ...state,
                loading: false
            };
        default: {
            return state;
        }
    }
};

export default leaveHistoryReducer;
